export default "__VITE_ASSET__COkPiiC4__"